import { Reveal, Eyebrow } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const FAQS = [
  {
    q: "What services does RCS provide?",
    a: "RCS provides website development, custom software development, SaaS development, mobile app development (Android & iOS), AI & automation, e-commerce development, UI/UX design and digital consultancy.",
  },
  {
    q: "Can RCS build a custom SaaS platform?",
    a: "Yes. RCS designs and builds multi-tenant SaaS platforms with subscriptions, user management, admin dashboards, payment integration and analytics — tailored to your business model.",
  },
  {
    q: "Can you build a School Management ERP?",
    a: "Yes — it is our flagship solution. RCS builds customized School Management SaaS covering admissions, attendance, fees, examinations, portals for parents/teachers/students, mobile apps, SMS notifications and more, with your school's own branding.",
  },
  {
    q: "Can you develop Android and iOS apps?",
    a: "Yes. We build modern mobile applications for Android and iOS using Flutter, with API integration, push notifications and payment support where required.",
  },
  {
    q: "Can you integrate payment gateways?",
    a: "Yes. We integrate payment gateways into websites, SaaS platforms, school fee systems and mobile apps, with server-side payment verification.",
  },
  {
    q: "Can you integrate APIs and third-party services?",
    a: "Yes. We build and integrate custom APIs and connect third-party services such as SMS providers, payment gateways, AI APIs and cloud services.",
  },
  {
    q: "Can you customize the software according to our business?",
    a: "Absolutely — that is the core of how RCS works. We don't force your business into a generic model; features, workflows, branding and access control are configured around your requirements.",
  },
  {
    q: "Do you provide post-launch support?",
    a: "Yes. RCS provides ongoing technical support, maintenance and continuous improvements after launch, so your product keeps evolving with your business.",
  },
  {
    q: "Can you build a website along with the SaaS platform?",
    a: "Yes. We can deliver your marketing website, product website and the SaaS platform itself as one cohesive package with consistent branding.",
  },
  {
    q: "How can I request a project consultation?",
    a: "Use the enquiry form below or the 'Get a Free Consultation' button. Tell us what you want to build and our team will get back to you.",
  },
];

export const FAQ = () => (
  <section id="faq" className="bg-white py-24 sm:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20">
        <Reveal>
          <Eyebrow>FAQ</Eyebrow>
          <h2 className="mt-5 font-jakarta text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl" data-testid="faq-heading">
            Questions,<br />Answered.
          </h2>
          <p className="mt-5 max-w-sm font-inter text-[14px] leading-relaxed text-slate-500">
            Everything businesses and schools usually ask before starting a project with RCS.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-slate-200" data-testid={`faq-item-${i + 1}`}>
                <AccordionTrigger
                  className="py-5 text-left font-jakarta text-[15px] font-semibold text-navy hover:text-gold hover:no-underline [&[data-state=open]]:text-gold"
                  data-testid={`faq-question-${i + 1}`}
                >
                  <span className="flex items-baseline gap-4">
                    <span className="font-mono2 text-[11px] font-medium text-slate-400">{String(i + 1).padStart(2, "0")}</span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-5 pl-9 font-inter text-[13.5px] leading-relaxed text-slate-500" data-testid={`faq-answer-${i + 1}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
